import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import {Collapse, Grid} from '@material-ui/core';
import Container from '@material-ui/core/Container';
import {Fieldset, Footer, InputRow, MultiFileSelect, TopNavBar} from '../../components'
import {getUserDataFromLocalStorage, onChangeInput, validateInputs} from "../../services/utils";
import {useStyles} from "../auth/signIn/authStyles";
import {initialState} from "./constant";
import {currencyOption, measurementUnitsOption} from '../../environment'
import HttpService from "../../services/http.service";
import Alert from "../../components/alert";
import axios from "axios";

export default function AddNewProduct(props) {
  const classes = useStyles();

  const pathName = props.location.pathname

  let user = getUserDataFromLocalStorage()
  const [state, setState] = useState(initialState);
  const harvestId = props?.location?.state?.item?.harvestId
  useEffect(() => {
    onChangeInput(user.firstName, 'purchasedFrom', state, setState)
  }, [])

  useEffect(() => {

    if (pathName.search('editproduct') >= 0) {
      const item = props.location.state.item ?? {};
      const {
        productDesciption,
        expectedYield,
        gardingRequested,
        manPowerRequested,
        priceSetByVendor,
        publishImmediately,
        digitalCurrAllowed,
        purchaseDate,
        discountCapture,
        purchasedFrom,
        avgWtSize,
        moistureValuePtg,
        moq,
        qty,
        qtyName,
        subSpeciesName,
        sectorId,
        measure,
        currency,
        countryId,
        stateId,
        cityId,
        gradingRequested,
        yieldDetailId,
        nutrientValue,
        insuranceDetails,
        insurerName,
        productPackSize,
        packsPerCartonContainer,
        avgLeadTime,
        transportMode,
        height,
        length,
        width,
        stockLocationCountry,
        originCountry,
        EAN,
        storageTemprature,
        offerPrivateLable,
        productNameLocalLanguage,
        internationalBarcodeAvailable,
      } = item
      const val = {
        cityId: cityId,
        gradingRequested: gardingRequested,
        manPowerRequested: manPowerRequested,
        publishImmediately: publishImmediately,
        priceSetByVendor: priceSetByVendor,
        purchasedDate: purchaseDate,
        purchasedFrom: purchasedFrom,
        avgWeightSize: avgWtSize,
        moisturePtg: moistureValuePtg,
        moq: moq,
        discountCapture,
        nutrientValue,
        insuranceDetails,
        insurerName,
        digitalCurrAllowed,
        qty,
        currency,
        countryId,
        stateId,
        qtyName:measure || qtyName,
        sectorId: sectorId?.agriSectorId || sectorId,
        yieldDetailId: yieldDetailId,
        expectedYield: expectedYield,
        subSpeciesName: subSpeciesName,
        description: productDesciption,
        multipleFiles: true,// to get multiple files input
        productPackSize,
        packsPerCartonContainer,
        avgLeadTime,
        transportMode,
        height,
        length,
        width,
        stockLocationCountry,
        originCountry,
        EAN,
        storageTemprature,
        offerPrivateLable,
        productNameLocalLanguage,
        internationalBarcodeAvailable
      }
      setState((preState) => ({
        ...preState, values: {...preState.values, ...val}
      }))
      // console.log(val1)
    }
  }, [props])

  const {values, errors} = state;
  const [countries, setCountries] = useState([])
  const [country, setCountry] = useState([])
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [yieldList, setYieldList] = useState([])
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [loading, setLoading] = useState(false)
  const checks = [{text: "Yes", value: "y"}, {text: "No", value: "n"}]
  let farming = JSON.parse(localStorage.getItem("farming") || "[]")
  const arr = []
  for (let i = 0; i < farming.length; i++) {
    arr.push({text: farming[i].agriSectorDescription, value: farming[i].agriSectorId})
  }
  //setSectorList(arr)
  useEffect(() => {
    let sectorId = values.sectorId
    if (sectorId) {
      for (let j = 0; j < farming.length; j++) {
        if (farming[j].agriSectorId == sectorId) {
          const arry = []
          for (let i = 0; i < farming[j].categories.length; i++) {
            arry.push({
              text:
                sectorId == 1 ? farming[j].categories[i].cropName :
                  sectorId == 2 ? farming[j].categories[i].agriFisherySubSpeciesName :
                    sectorId == 3 ? farming[j].categories[i].liveStockCategoryDesc : "undefined",
              value:
                sectorId == 1 ? farming[j].categories[i].cropDetailsId :
                  sectorId == 1 ? farming[j].categories[i].agriFisherySubSpeciesId :
                    sectorId == 1 ? farming[j].categories[i].liveStockCategoryId : "1"
            })
          }
          setYieldList(arry)
        }
      }
    }

  }, [values.sectorId]);

  useEffect(() => {
    setStateList([])
    HttpService.get('marketplace/countriesList').then(res => {
      if (res) {
        let list = res.data;
        let len = (list && list.length) || 0;
        const array = []
        for (let i = 0; i < len; i++) {
          array.push({text: list[i].countryName, value: list[i].countryID})
        }
        setCountries(array)
        let arr = [...array]
        arr.unshift({text: "Global", value: "global"});
        setCountry(arr)
      }
    });
  }, []);
  useEffect(() => {
    // let country = "UAE"
    let country = values.countryId
    if (country) {
      HttpService.get(`marketplace/statesByCountry/${country}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].stateName, value: list[i].stateID})

          }
          setStateList(array)
        }
      });
    }

  }, [values.countryId]);
  useEffect(() => {
    // let state = "5347"
    let state = values.stateId
    // setCityList([])
    if (state) {
      HttpService.get(`marketplace/cityByStates/${state}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].cityName, value: list[i].cityID})
          }
          console.log(array)
          setCityList(array)
        }
      });
    }

  }, [values.stateId]);

  const addProduct = (e) => {
    e.preventDefault();
    setLoading(true)
    console.log("fff", values.file)
    let {
      expectedYield,
      file,
      cityId,
      gradingRequested,
      manPowerRequested,
      priceSetByVendor,
      publishImmediately,
      purchasedDate,
      purchasedFrom,
      qty,
      qtyName,
      subSpeciesName,
      discountCapture,
      sectorId,
      description,
      avgWeightSize,
      moisturePtg,
      moq,
      yieldDetailId,
      isEnsured,
      insurerName,
      insuranceCertificate,
      nutrientValue,
      currency,
      insuranceDetails,
      digitalCurrAllowed,
      productPackSize,
      packsPerCartonContainer,
      avgLeadTime,
      transportMode,
      height,
      length,
      width,
      stockLocationCountry,
      originCountry,
      EAN,
      storageTemprature,
      offerPrivateLable,
      productNameLocalLanguage,
      internationalBarcodeAvailable
    } = values;
    let data = {
      expectedYield,
      file,
      cityId,
      gradingRequested,
      manPowerRequested,
      priceSetByVendor,
      publishImmediately,
      purchasedDate,
      purchasedFrom,
      discountCapture,
      qty,
      qtyName,
      subSpeciesName,
      sectorId,
      avgWeightSize,
      moisturePtg,
      moq,
      currency,
      yieldDetailId,
      productPackSize,
      packsPerCartonContainer,
      avgLeadTime,
      transportMode,
      height,
      length,
      width,
      stockLocationCountry,
      originCountry,
      EAN,
      storageTemprature,
      offerPrivateLable,
      productNameLocalLanguage,
      internationalBarcodeAvailable
    };

    let recordedErrors = validateInputs(data);
    if (isEnsured)
      isEnsured = 'y'
    else
      isEnsured = 'n'
    if (values.qty <= 0) {
      recordedErrors.qty = "Quantity should be greater then 0"
    }
    if (values.priceSetByVendor <= 0) {
      recordedErrors.priceSetByVendor = "Price should be greater then 0"
    }
    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let bodyFormData = new FormData();
      bodyFormData.append('file', file);
      HttpService.post(`product/saveProduct?discountCapture=${discountCapture}&expectedYield=${expectedYield}&currency=${currency}&gradingRequested=${gradingRequested}&manPowerRequested=${manPowerRequested}&priceSetByVendor=${priceSetByVendor}&publishImmediately=${publishImmediately}&purchasedDate=${purchasedDate}&purchasedFrom=${purchasedFrom}&qty=${qty}&cityId=${cityId}&qtyName=${qtyName}&subSpeciesName=${subSpeciesName}&userId=${user?.ssoId}&ssoId=${user?.ssoId}&sectorId=${sectorId}&yieldDetailId=${yieldDetailId}&productDesciption=${description}&avgWeightSize=${avgWeightSize}&moisturePtg=${moisturePtg}&moq=${moq}&isEnsured=${isEnsured}&insurerName=${insurerName}&insuranceCertificate=${insuranceCertificate}&nutrientValue=${nutrientValue}&insuranceDetails=${insuranceDetails}&digitalCurrAllowed=${digitalCurrAllowed}&pmtGwllowed=n&productPackSize=${productPackSize}&packsPerCartonContainer=${packsPerCartonContainer}&avgLeadTime=${avgLeadTime}&transportMode=${transportMode}&height=${height}&length=${length}&width=${width}&stockLocationCountry=${stockLocationCountry}&originCountry=${originCountry}&EAN=${EAN}&storageTemprature=${storageTemprature}&offerPrivateLable=${offerPrivateLable}&productNameLocalLanguage=${productNameLocalLanguage}&internationalBarcodeAvailable=${internationalBarcodeAvailable}&priority=1`, bodyFormData).then(res => {
        if (res) {
          if (res?.data?.message == "SUCCESS")
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            setSuccess("")
          }, 8000);
        } else
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 8000);
        setLoading(false)
      }).catch(res=>{
         setError("Server Error")
        setTimeout(() => {
          setError("")
        }, 8000);
        setLoading(false)
      });
    }
  };

  const editProduct = (e) => {
    e.preventDefault();
    setLoading(true)
    console.log("fff", values.file)
    let {
      expectedYield,
      file,
      cityId,
      gradingRequested,
      manPowerRequested,
      priceSetByVendor,
      publishImmediately,
      purchasedDate,
      purchasedFrom,
      qty,
      qtyName,
      subSpeciesName,
      sectorId,
      description,
      avgWeightSize,
      moisturePtg,
      moq,
      yieldDetailId,
      discountCapture,
      isEnsured,
      insurerName,
      insuranceCertificate,
      nutrientValue,
      currency,
      insuranceDetails,
      digitalCurrAllowed,
      productPackSize,
      packsPerCartonContainer,
      avgLeadTime,
      transportMode,
      height,
      length,
      width,
      stockLocationCountry,
      originCountry,
      EAN,
      storageTemprature,
      offerPrivateLable,
      productNameLocalLanguage,
      internationalBarcodeAvailable
    } = values;
    let data = {
      expectedYield,
      file,
      cityId,
      gradingRequested,
      manPowerRequested,
      priceSetByVendor,
      publishImmediately,
      purchasedDate,
      purchasedFrom,
      qty,
      qtyName,
      subSpeciesName,
      discountCapture,
      sectorId,
      avgWeightSize,
      moisturePtg,
      moq,
      currency,
      yieldDetailId,
      productPackSize,
      packsPerCartonContainer,
      avgLeadTime,
      transportMode,
      height,
      length,
      width,
      stockLocationCountry,
      originCountry,
      EAN,
      storageTemprature,
      offerPrivateLable,
      productNameLocalLanguage,
      internationalBarcodeAvailable
    };

    let recordedErrors = validateInputs(data);
    if (isEnsured)
      isEnsured = 'y'
    else
      isEnsured = 'n'
    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let bodyFormData = new FormData();
      bodyFormData.append('file', file);
      try {


      HttpService.post(`product/editProduct?discountCapture=${discountCapture}&expectedYield=${expectedYield}&currency=${currency}&gradingRequested=${gradingRequested}&manPowerRequested=${manPowerRequested}&priceSetByVendor=${priceSetByVendor}&publishImmediately=${publishImmediately}&purchasedDate=${purchasedDate}&purchasedFrom=${purchasedFrom}&qty=${qty}&cityId=${cityId}&qtyName=${qtyName}&subSpeciesName=${subSpeciesName}&userId=${user?.ssoId}&ssoId=${user?.ssoId}&sectorId=${sectorId}&yieldDetailId=${yieldDetailId}&productDesciption=${description}&avgWeightSize=${avgWeightSize}&moisturePtg=${moisturePtg}&moq=${moq}&isEnsured=${isEnsured}&insurerName=${insurerName}&insuranceCertificate=${insuranceCertificate}&nutrientValue=${nutrientValue}&insuranceDetails=${insuranceDetails}&digitalCurrAllowed=${digitalCurrAllowed}&pmtGwllowed=n&productPackSize=${productPackSize}&packsPerCartonContainer=${packsPerCartonContainer}&avgLeadTime=${avgLeadTime}&transportMode=${transportMode}&height=${height}&length=${length}&width=${width}&stockLocationCountry=${stockLocationCountry}&originCountry=${originCountry}&EAN=${EAN}&storageTemprature=${storageTemprature}&offerPrivateLable=${offerPrivateLable}&productNameLocalLanguage=${productNameLocalLanguage}&internationalBarcodeAvailable=${internationalBarcodeAvailable}`, bodyFormData).then(res => {
        if (res) {
          if (res?.data?.message == "SUCCESS")
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            setSuccess("")
          }, 8000);
        } else
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 8000);
        setLoading(false)
      }).catch(res=>{
        setError("Server Error")
        setTimeout(() => {
          setError("")
        }, 8000);
        setLoading(false)
      });
      } catch (error) {
        setError("Server Error")
        setTimeout(() => {
          setError("")
        }, 8000);
        setLoading(false)
      }
    }
  }
  const upload = async (e) => {

    // Convert the FileList into an array and iterate
    let files = Array.from(e.target.files).map(file => {

      // Define a new file reader
      let reader = new FileReader();

      // Create a new promise
      return new Promise(resolve => {

        // Resolve the promise after reading file
        reader.onload = () => resolve(reader.result);

        // Reade the file as a text
        // reader.readAsText(file);

      });

    });

    // At this point you'll have an array of results
    return await Promise.all(files);

  }
  const fileInput = (event) => {
    upload(event).then(data => console.log(data))
  }

  const path = '/addproduct';

  const uploadMultiplefiles = (e) => {
    e.preventDefault()
    console.log('upload multiple files')
    let bodyFormData = new FormData();
    values.filesList.forEach(file => {
      bodyFormData.append("file", file);
    });
    try {
      axios({
        method: "POST",
        url: `https://www.agrilivemarket.com/rest/api/edit/uploadFile/V3?harvestId=${harvestId}&ssoId=${user.ssoId}`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      setSuccess("images uploaded")
      setTimeout(() => {
        setSuccess("")
      }, 8000);
    } catch (error) {
      setError("error in uploading images")
      setTimeout(() => {
        setError("")
      }, 8000);
    }
  }
  //
  const uploadCert = (e) => {
    e.preventDefault()
    console.log('upload multiple files')
    let bodyFormData = new FormData();
    bodyFormData.append("imgCertificate", values.certFile);
    try {
      axios({
        method: "POST",
        url: `https://www.agrilivemarket.com/rest/api/uploadCertificate/?certificate=cert&provider=${user.firstName}&harvest=${harvestId}&ssoId=${user.ssoId}`,
        data: bodyFormData
      })
      setSuccess("Certificate uploaded")
      setTimeout(() => {
        setSuccess("")
      }, 8000);
    } catch (error) {
      setError("error in uploading Certificate")
      setTimeout(() => {
        setError("")
      }, 8000);
    }
  }

  useEffect(() => {
    let val = values.discountCapture;
    let price = values.priceSetByVendor;
    let dis = 0
    if (price && val) {
     // dis = (val * price) / 100;
      dis = price-(Number(price)*Number(val)/100)
    } else {
      dis = 0;
    }
    console.log(dis)
    onChangeInput(dis, 'discountAmount', state, setState)
  }, [values.priceSetByVendor, values.discountCapture,])
  return (
    <>
      {((error || success)) && <Alert type={error ? 'error' : 'success'} message={error || success}/>}

      {pathName === path && <TopNavBar/>}
      <Container
        maxWidth={pathName === path && 'sm'}
        // className={`mb-20 ${pathName != '/newproduct' && ' content-container6 '}`}
      >
        <div className={classes.paper} style={{marginTop: pathName !== path && 0}}>
          <h1
            className=' heading-color'>{(pathName === path || pathName === '/newproduct') ? 'Add Products' : 'Edit Product'}</h1>
          <form className={classes.form} validate>
            <Fieldset
              title={'product information'}
              children={<>
                <InputRow
                  types={[
                    {
                      type: 'select',
                      value: values.sectorId,
                      error: errors.sectorId,
                      label: 'product Category',
                      id: 'sectorId',
                      dropdownList: arr
                    }, {
                      type: 'select',
                      value: values.yieldDetailId,
                      error: errors.yieldDetailId,
                      label: 'product Type',
                      id: 'yieldDetailId',
                      dropdownList: yieldList
                    },
                    {
                      value: values.subSpeciesName,
                      error: errors.subSpeciesName,
                      placeholder:"LiveAgri Toor Dal 800 Gram",
                      label: 'sub Species Name',
                      id: 'subSpeciesName'
                    },
                    {
                      type: 'select',
                      value: values.countryId,
                      error: errors.countryId,
                      label: 'country',
                      id: 'countryId',
                      dropdownList: countries
                    }, {
                      type: 'select',
                      value: values.stateId,
                      error: errors.stateId,
                      label: 'state',
                      id: 'stateId',
                      dropdownList: stateList
                    }, {
                      type: 'select',
                      value: values.cityId,
                      error: errors.cityId,
                      label: 'city',
                      id: 'cityId',
                      dropdownList: cityList
                    },
                    {
                      type: 'file',
                      value: values.file?.name ?? '',
                      error: errors.file,
                      label: 'Product Image',
                      id: 'file',
                      accept: 'image/*'
                    },


                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={3}
                />
                <InputRow
                  types={[
                    {
                      value: values.description,
                      error: errors.description,
                      label: 'description',
                      rows: 3,
                      maxLength: 700,
                      placeholder:' max characters 700'
                    },

                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={1}
                />
              </>}
            />

            <div className='mt-30'>
              <Fieldset
                title='product quantity & price'
                children={
                  <InputRow
                    types={[
                      {type: 'number', min: 0, value: values.qty, error: errors.qty, id: 'qty', label: 'quantity'},
                      {
                        value: values.avgWeightSize,
                        error: errors.avgWeightSize,
                        id: 'avgWeightSize',
                        label: 'avgWeight/ Packet Size',
                        type: 'number',
                        min: 0,
                      },
                      {
                        type: 'select',
                        value: values.qtyName,
                        error: errors.qtyName,
                        label: 'Measurement Unit',
                        id: 'qtyName',
                        dropdownList: measurementUnitsOption
                      },
                      {
                        type: 'select',
                        value: values.currency,
                        error: errors.currency,
                        label: 'currency',
                        dropdownList: currencyOption
                      },
                      {
                        type: 'number',
                        min: 0,
                        value: values.priceSetByVendor,
                        error: errors.priceSetByVendor,
                        id: 'priceSetByVendor',
                        label: 'Price',
                      },
                      {
                        type: 'number',
                        value: values.discountCapture,
                        error: errors.discountCapture,
                        label: 'discount %',
                        id: 'discountCapture',
                        min: 0, max: 100,
                        required: false,
                      }, {
                        value: values.discountAmount,
                        error: errors.discountAmount,
                        label: 'discounted Amount',
                        disable: true,
                        required: false
                      },
                      {
                        type: 'number',
                        min: 0,
                        value: values.moq,
                        error: errors.moq,
                        label: 'minimum quantity allowed',
                        id: 'moq'
                      },
                      {
                        type: 'select',
                        value: values.digitalCurrAllowed,
                        label: 'digital Currency Allowed',
                        id: 'digitalCurrAllowed',
                        dropdownList: checks
                      },
                      ...(values.sectorId != 3) ? [{
                        type: 'number',
                        value: values.moisturePtg,
                        error: errors.moisturePtg,
                        id: 'moisturePtg',
                        label: 'moisture %',
                        min: 0,
                        max: 100
                      }] : [],


                      // {value: values.qtyName, error: errors.qtyName, label: 'qtyName'},

                      // {value: values.sectorId, error: errors.sectorId, label: 'sectorId'},
                      {
                        type: 'number',
                        value: values.expectedYield,
                        error: errors.expectedYield,
                        label: 'expected Yield',
                        id: 'expectedYield'
                      },
                      {
                        type: 'number',
                        value: values.nutrientValue,
                        error: errors.nutrientValue,
                        label: 'nutrient Value',
                        id: "nutrientValue"
                      },
                    ]}
                    onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                    numOfInputPerRow={3}
                  />}
              />
            </div>
            <div className='mt-30'>
              <Fieldset
                title='services'
                children={
                  <InputRow
                    types={[
                      {
                        type: 'select',
                        value: values.gradingRequested,
                        error: errors.gradingRequested,
                        label: 'grading Requested',
                        id: 'gradingRequested',
                        dropdownList: checks
                      },
                      {
                        type: 'select',
                        value: values.manPowerRequested,
                        error: errors.manPowerRequested,
                        label: 'ManPower Requested',
                        id: 'manPowerRequested',
                        dropdownList: checks
                      },
                      {
                        type: 'select',
                        value: values.publishImmediately,
                        error: errors.publishImmediately,
                        label: 'publish Immediately',
                        id: 'publishImmediately',
                        dropdownList: checks
                      },

                    ]}
                    onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                    numOfInputPerRow={3}
                  />
                }/>
            </div>
            <div className='mt-30'>
              <Fieldset
                title='3rd party (if any)'
                children={
                  <InputRow
                    types={[

                      {
                        type: 'date',
                        value: values.purchasedDate,
                        error: errors.purchasedDate,
                        id: 'purchasedDate',
                        label: 'purchased Date'
                      },
                      {
                        value: values.purchasedFrom,
                        error: errors.purchasedFrom,
                        id: 'purchasedFrom',
                        label: 'purchased From'
                      },

                    ]}
                    onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                    numOfInputPerRow={3}
                  />
                }/>
            </div>
            {values.multipleFiles && <div className='mt-30'>
              <Fieldset
                title={'Add additional files'}
                children={

                  <>
                    <MultiFileSelect
                      state={state}
                      setState={setState}
                      maxSize={2097152}
                      noOfFiles={5}
                      id={'filesList'}
                      label={' select files upto 5  '}
                      accept={'image/*'}
                    />
                    {values.filesList.length > 0 &&
                    <Grid lg={12} xs={12} className={'mt-20 display-flex justify-content-end'}>
                      <Button type="submit" variant="contained" color="primary" onClick={uploadMultiplefiles}>
                        Upload files
                      </Button>
                    </Grid>
                    }
                  </>

                }/>
            </div>}
            <div className='mt-30'>
              <Fieldset
                title={'Insurance'}
                children={
                  <>
                    <InputRow
                      types={[
                        {type: 'checkbox', value: values.isEnsured, id: 'isEnsured', label: 'Product Insured '},
                      ]}
                      onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                      numOfInputPerRow={1}
                    />
                    <Collapse in={values.isEnsured} className='mt-10'>
                      <InputRow
                        types={[
                          {value: values.insurerName, error: errors.insurerName, label: 'insurerName'},
                          {value: values.insuranceDetails, error: errors.insuranceDetails, label: 'insuranceDetails'},
                          {
                            type: 'file',
                            // min: 0,
                            value: values.insuranceCertificate?.name,
                            error: errors.insuranceCertificate,
                            label: 'insuranceCertificate',
                          },
                        ]}
                        onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                        numOfInputPerRow={3}
                      />
                    </Collapse>
                  </>
                }/>
            </div>
            <div className='mt-30'>
              <Fieldset
                  title={'Fulfillment'}
                  children={
                    <>
                      <Collapse in={values.isEnsured} className='mt-10'>
                        <InputRow
                            types={[
                              {value: values.productPackSize, error: errors.productPackSize, id: "productPackSize", label: 'Product-pack-size'},
                              {value: values.packsPerCartonContainer, error: errors.packsPerCartonContainer, id: "packsPerCartonContainer", label: 'Number-of-packs-per-carton/container'},
                              {value: values.avgLeadTime, error: errors.avgLeadTime, id: "avgLeadTime", label: 'Avg Lead Time'},
                              {value: values.transportMode, error: errors.transportMode, id: "transportMode", label: 'transport Mode'},
                            ]}
                            onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                            numOfInputPerRow={2}
                        />
                      </Collapse>
                    </>
                  }/>
            </div>
            <div className='mt-30'>
              <Fieldset
                  title={'Dimensions'}
                  children={
                    <>
                      <Collapse in={values.isEnsured} className='mt-10'>
                        <InputRow
                            types={[
                              {type: 'number', value: values.height, error: errors.height, label: 'height'},
                              {type: 'number', value: values.length, error: errors.length, label: 'length'},
                              {type: 'number', value: values.width, error: errors.width, label: 'width'},
                            ]}
                            onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                            numOfInputPerRow={3}
                        />
                      </Collapse>
                    </>
                  }/>
            </div>
            <div className='mt-30'>
              <Fieldset
                  title={'Others'}
                  children={
                    <>
                      <Collapse in={values.isEnsured} className='mt-10'>
                        <InputRow
                            types={[
                              {
                                type: 'select',
                                value: values.stockLocationCountry,
                                error: errors.stockLocationCountry,
                                label: 'stock Location Country',
                                id: 'stockLocationCountry',
                                dropdownList: country
                              },
                              {
                                type: 'select',
                                value: values.originCountry,
                                error: errors.originCountry,
                                label: 'origin Country',
                                id: 'originCountry',
                                dropdownList: country
                              },
                              {value: values.EAN, error: errors.EAN, label: 'EAN'},
                              {value: values.storageTemprature, error: errors.storageTemprature,label: 'storage Temperature' ,id: 'storageTemprature'},
                              {value: values.offerPrivateLable, error: errors.offerPrivateLable,label: 'offer Private Label' ,id: 'offerPrivateLable'},
                              {value: values.productNameLocalLanguage, error: errors.productNameLocalLanguage, label: 'product Name Local Language',id: 'productNameLocalLanguage'},
                              {value: values.internationalBarcodeAvailable, error: errors.internationalBarcodeAvailable,  label: 'international Barcode Available', id: 'internationalBarcodeAvailable'},
                            ]}
                            onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                            numOfInputPerRow={3}
                        />
                      </Collapse>
                    </>
                  }/>
            </div>

            <Grid container spacing={2} className='mt-20 mb-20 pl-10  pr-10'>
              <Grid item lg={12} xs={12}
                    className={pathName !== path ? '  display-flex justify-content-end' : ''}>
                {/*<br></br>*/}
                {!loading &&
                <Button type="submit" fullWidth={pathName === path} variant="contained" color="primary"
                        onClick={(e) => {
                          pathName.search('editproduct') > 0 ? editProduct(e) : addProduct(e)
                        }}
                >
                  {pathName.search('editproduct') > 0 ? 'Edit OR Save product' : 'Add Product'}
                </Button>
                }
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
      <div>
        <br></br>
        <br></br>
      </div>
      {pathName === path && <Footer auth={false}/>}
    </>
  );
}


// [9:48 PM, 12/1/2021] +971 50 954 8229: You may view it after login
//   [9:48 PM, 12/1/2021] +971 50 954 8229: http://52.213.78.242/farmerDashBoard/
//   [9:48 PM, 12/1/2021] +971 50 954 8229: 03335513435 is username and password is abc$321
